import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../shared';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { HcPatientConsultationHdrContainerModel } from '../../../../../models/aggregates/healthcare/patient_consultation_hdr_container.model';

@Injectable({ providedIn: 'root' })
export class HcPatientConsultationHdrLoginEpService extends BaseApiTemplateService<HcPatientConsultationHdrContainerModel> {
    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + "patient-consultation-hdrs";

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'patient-consultation-hdrs' + '/login-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'patient-consultation-hdrs' + '/login-ep';
        this.httpClient = http;
    }
}